/**
 * Rebalance questionnaire route tree.
 *
 * Belongs here: Route elements for the questionnaire and the profile screen.
 * Does not belong here: the old `/rebalance-questionnaire` static route.
 */
import { Route } from 'react-router-dom'
import { RebalanceQuestionnaireProvider } from './RebalanceQuestionnaireProvider'
import { REBALANCE_QUESTIONNAIRE_ROUTES } from './rebalanceQuestionnairePaths'
import RebalanceQuestionnairePage from './pages/RebalanceQuestionnairePage'
import RebalanceRiskProfilePage from './pages/RebalanceRiskProfilePage'

export const RebalanceQuestionnaireRoutes = () => {
  return [
    <Route key="rebalance-questionnaire" element={<RebalanceQuestionnaireProvider />}>
      <Route path={REBALANCE_QUESTIONNAIRE_ROUTES.root} element={<RebalanceQuestionnairePage />} />
      <Route path={REBALANCE_QUESTIONNAIRE_ROUTES.riskProfile} element={<RebalanceRiskProfilePage />} />
    </Route>
  ]
}
